import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { getConversionDetailDataByDate } from "../../ActionCreator";
import moment from "moment";

const targetData = [
  { name: "Overall", target: 30, actual: 16 },
  { name: "Maharashtra", target: 30, actual: 16 },
  { name: "Karnataka", target: 30, actual: 16 },
  { name: "Tamil Nadu", target: 30, actual: 16 },
  { name: "Rajasthan", target: 30, actual: 16 },
  { name: "Delhi", target: 30, actual: 16 },
];

const deviationData = [
  { name: "Maharashtra", value: -3 },
  { name: "Karnataka", value: 2 },
  { name: "Tamil Nadu", value: -3 },
  { name: "Delhi", value: 2 },
  { name: "Gujarat", value: -1 },
  { name: "Noida", value: -2 },
  { name: "Rajkot", value: -4 },
  { name: "Bengaluru", value: -5 },
  { name: "Chennai", value: 2 },
];

const Conversion = ({ appliedDate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [conversionData, setConversionData] = useState([]);

  console.log("conversionData", conversionData);

  const getAggregatorData = () => {
    const sDate = appliedDate?.from
      ? moment(appliedDate.from).format("DD-MM-YYYY")
      : "";
    const eDate = appliedDate?.to
      ? moment(appliedDate.to).format("DD-MM-YYYY")
      : "";
    setIsLoading(true);
    getConversionDetailDataByDate(sDate, eDate, (res) => {
      setIsLoading(false);
      const data = res?.data?.filter((item) => item?.aggregatorName);
      setConversionData(data);
    });
  };

  useEffect(() => {
    getAggregatorData();
  }, [appliedDate]);

  return (
    <div className="conversion-container">
      <div
        className="row"
        style={{
          marginBottom: "50px",
          marginLeft: "2px",
          marginRight: "2px",
        }}
      >
        <div className="card-box">
          <div className="row">
            <div className="col-lg-9 px-0">
              <div>
                <h5 className="common-heading">Target vs Actual Conversion</h5>

                <ResponsiveContainer width="100%" height={280}>
                  <BarChart data={conversionData}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <XAxis dataKey="aggregatorName" axisLine={{ stroke: "#0000001f", strokeWidth: 1 }} />
                    <YAxis  axisLine={{ stroke: "#0000001f", strokeWidth: 1 }}/>
                    <Tooltip />
                    <Bar
                      dataKey="targetDisbursement"
                      fill="#4e79a7"
                      radius={[4, 4, 0, 0]}
                    />
                    <Bar
                      dataKey="actualDisbursement"
                      fill="#59a14f"
                      radius={[4, 4, 0, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className=" col-lg-3 col-xs-12">
              <div className="summary" style={{border:'none'}}>
                {conversionData?.map((item) => (
                  <div
                    className={`${item?.deviationPercent > 0 ? "good" : "bad"}`}
                  >
                    {item?.aggregatorName}{" "}
                    <span>{`${item?.deviationPercent} %`}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-box mt-3">
        <div className="header" style={{ marginBottom: '15px' }}>
          <h5 className="common-heading">Performance Deviation Analysis</h5>
          {/* <select className="mb-3">
            <option>Select an Option</option>
          </select> */}
        </div>

        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={conversionData}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="aggregatorName"  axisLine={{ stroke: "#0000001f", strokeWidth: 1 }}/>
            <YAxis  axisLine={{ stroke: "#0000001f", strokeWidth: 1 }}/>
            <Tooltip />
            <Bar
              dataKey="deviationPercent"
              radius={[4, 4, 0, 0]}
              fill="#8884d8"
              shape={(props) => {
                const { x, y, width, height, value } = props;
                return (
                  <rect
                    x={x}
                    y={y}
                    width={width}
                    height={height}
                    fill={value >= 0 ? "#4fa463" : "#e74c3c"}
                  />
                );
              }}
            />
          </BarChart>
        </ResponsiveContainer>

        <div className="row mt-3" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>
          <div className="col-lg-5">
            <div className="summary-box green">
              <h5>
                Above Target{" "}
                <span>
                  {
                    conversionData?.filter((item) => item?.deviationPercent > 0)
                      .length
                  }
                </span>
              </h5>
              {conversionData
                ?.filter((item) => item?.deviationPercent > 0)
                .map((item) => (
                  <p>
                    {item?.aggregatorName} {item?.deviationPercent} %
                  </p>
                ))}
            </div>
          </div>

          <div className="col-lg-5">
            <div className="summary-box red">
              <h5>
                Below Target{" "}
                <span>
                  {
                    conversionData?.filter((item) => item?.deviationPercent < 0)
                      .length
                  }
                </span>
              </h5>
              {conversionData
                ?.filter((item) => item?.deviationPercent < 0)
                .map((item) => (
                  <p>
                    {item?.aggregatorName} {item?.deviationPercent} %
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Conversion;
